import solomahineRanchLogo from '../../assets/partners-page-images/solomahine-ranch.png';
import igoGoRanchLogo from '../../assets/partners-page-images/igo-go-ranch.png';
import horseParadiseLogo from '../../assets/partners-page-images/horse-paradise.png';
import carouselRanchLogo from '../../assets/partners-page-images/carousel-ranch.png';
import dreamPowerLogo from '../../assets/partners-page-images/dream-power.png';
import fenixProjectLogo from '../../assets/partners-page-images/fenix-project.png';
import horseSportLogo from '../../assets/partners-page-images/horse-sport.png';
import leadershipLogo from '../../assets/partners-page-images/leadership.png';
import peaceBringersLogo from '../../assets/partners-page-images/peace-bringers.png';
import mariupolLogo from '../../assets/partners-page-images/mariupol.png';
import mvsLogo from '../../assets/partners-page-images/mvs.png';
import policeLogo from '../../assets/partners-page-images/police.png';
import veterankaLogo from '../../assets/partners-page-images/veteranka.png';
import childrenAffeirsLogo from "../../assets/partners-page-images/children's-affeirs.png";
import liveLogo from '../../assets/partners-page-images/live.png';
import yoUkraineLogo from '../../assets/partners-page-images/YOUkraine.png';
import dsnsLogo from '../../assets/partners-page-images/dsns.png';
import printHubLogo from '../../assets/partners-page-images/print-hub.png';
import awesomicLogo from '../../assets/partners-page-images/awesomic.png';
import usEmbassyLogo from '../../assets/partners-page-images/us-embassy.png';
import nomCourseLogo from '../../assets/partners-page-images/nom-course.png';
import zeneduLogo from '../../assets/partners-page-images/zenedu.png';
import acaBureauLogo from '../../assets/partners-page-images/aca-bureau.png';
import artNavigatorLogo from '../../assets/partners-page-images/art-navigator.png';
import carpathianEnergyLogo from '../../assets/partners-page-images/carpathian-energy.png';
import psychologyFacultyLogo from '../../assets/partners-page-images/psychology-faculty.png';

export const PARTNERS_PAGE_TITLE = {
    FIRST_LINE: {
        REGULAR: 'МИ',
        BOLD: ' НЕ ОДНІ.',
    },
    SECOND_LINE: {
        BOLD_START: 'І ЦЕ ',
        REGULAR: 'НАША',
        BOLD_END: ' СИЛА ',
    },
};

export const PARTNERS_PAGE_SUBTITLE = 'Дякуємо тим, хто разом із нами!';

export const PARTNERS_FIRST_SECTION_TITLE = {
    FIRST_LINE: 'Ті, хто відкрили нам свої ',
    SECOND_LINE: 'простори задля зцілення',
};

export const PARTNERS_FIRST_SECTION_DESCRIPTION = {
    FIRST_LINE: 'Ранчо, завдяки яким учасники відчувають ',
    SECOND_LINE: 'спокій, свободу та силу коней.',
};

export const PARTNERS_SECOND_SECTION_TITLE = {
    FIRST_LINE: 'Ті, хто розділяють з нами ',
    SECOND_LINE: 'бачення майбутнього',
};

export const PARTNERS_SECOND_SECTION_DESCRIPTION = {
    FIRST_LINE: 'Разом ми будуємо сильну спільноту, де знання, досвід і підтримка стають ',
    SECOND_LINE: 'фундаментом для зростання та змін.',
};

export const PARTNERS_THIRD_SECTION_TITLE = {
    FIRST_LINE: 'Ті, з ким ми створювали ',
    SECOND_LINE: 'зміни тут і зараз',
};

export const PARTNERS_THIRD_SECTION_DESCRIPTION = {
    FIRST_LINE: 'Пліч-о-пліч ми реалізували програми, що ',
    SECOND_LINE: 'зцілили десятки сердець.',
};

export const PARTNERS_FOURTH_SECTION_TITLE = {
    FIRST_LINE: 'Ті, чия підтримка була ',
    SECOND_LINE: 'безцінною',
};

export const PARTNERS_FOURTH_SECTION_DESCRIPTION = {
    FIRST_LINE: 'Різні за підходом, але єдині у намірі — вони ',
    SECOND_LINE: 'стали частиною нашого шляху до перемоги',
};

export const OUTRO = {
    TITLE: {
        FIRST_LINE: 'Коли сили об’єднуються',
        SECOND_LINE: 'народжується надія',
    },
    TEXT: 'Ми віримо в силу спільноти, єдності і в те, що разом ми здатні повертати світло туди, де його було втрачено.Запрошуємо вас стати частиною історії зцілення та перемоги!',
    BUTTON_BECOME_SUPPORT_TEXT: 'Стати партнером',
    BUTTON_SUPPORT_TEXT: 'Підтримати',
};

export const PARTNER_FIRST_SECTION = [
    {
        id: 1,
        name: 'Соломахине ранчо',
        logo: solomahineRanchLogo,
        description: 'Соломахине ранчо',
    },
    {
        id: 2,
        name: 'Ранчо "Іго-Го"',
        logo: igoGoRanchLogo,
        description: 'Ранчо "Іго-Го"',
    },
    {
        id: 3,
        name: 'Соціальне ранчо "HorseParadise"',
        logo: horseParadiseLogo,
        description: 'Сучасне ранчо з повним комплексом послуг',
    },
];

export const PARTNER_SECOND_SECTION = [
    {
        id: 1,
        name: 'Carousel Ranch',
        logo: carouselRanchLogo,
        description: 'Carousel Ranch',
    },
    {
        id: 2,
        name: 'Fenix Project',
        logo: fenixProjectLogo,
        description: 'Fenix Project',
    },
    {
        id: 3,
        name: 'Dream Power Horsemanship',
        logo: dreamPowerLogo,
        description: 'Dream Power Horsemanship',
    },
    {
        id: 4,
        name: 'International visitor leadership program ',
        logo: leadershipLogo,
        description: 'International visitor leadership program ',
    },
    {
        id: 5,
        name: 'Спілка UEATARA',
        logo: horseSportLogo,
        description: 'Спілка UEATARA',
    },
    {
        id: 6,
        name: 'ГО “Носителі миру”',
        logo: peaceBringersLogo,
        description: 'ГО “Носителі миру”',
    },
];

export const PARTNER_THIRD_SECTION = [
    {
        id: 1,
        name: 'БФ Маріуполь',
        logo: mariupolLogo,
        description: 'БФ Маріуполь',
    },
    {
        id: 2,
        name: 'ДУ “Головний медичний клінічний центр МВС України”',
        logo: policeLogo,
        description: 'ДУ “Головний медичний клінічний центр МВС України”',
    },
    {
        id: 3,
        name: 'Національна поліція України',
        logo: mvsLogo,
        description: 'Національна поліція України',
    },
    {
        id: 4,
        name: 'Жіночий ветеранський рух “VETERANKA”',
        logo: veterankaLogo,
        description: 'Жіночий ветеранський рух “VETERANKA”',
    },
    {
        id: 5,
        name: 'Державна служба України у справах дітей',
        logo: childrenAffeirsLogo,
        description: 'Державна служба України у справах дітей',
    },
    {
        id: 6,
        name: 'Проєкт “Жива”',
        logo: liveLogo,
        description: 'Проєкт “Жива”',
    },
    {
        id: 7,
        name: 'YOUkraine Hub',
        logo: yoUkraineLogo,
        description: 'YOUkraine Hub',
    },
    {
        id: 8,
        name: 'ДСНС',
        logo: dsnsLogo,
        description: 'ДСНС',
    },
];

export const PARTNER_FOURTH_SECTION = [
    {
        id: 1,
        name: 'PrintHub saks',
        logo: printHubLogo,
        description: 'PrintHub saks',
    },
    {
        id: 2,
        name: 'Awesomic',
        logo: awesomicLogo,
        description: 'Awesomic',
    },
    {
        id: 3,
        name: 'Посольство США в Україні',
        logo: usEmbassyLogo,
        description: 'Посольство США в Україні',
    },
    {
        id: 4,
        name: 'Валерія Бородіна (NOM course)',
        logo: nomCourseLogo,
        description: 'Валерія Бородіна (NOM course)',
    },
    {
        id: 5,
        name: 'Zenedu',
        logo: zeneduLogo,
        description: 'Zenedu',
    },
    {
        id: 6,
        name: 'ACA BUREAU',
        logo: acaBureauLogo,
        description: 'ACA BUREAU',
    },
    {
        id: 7,
        name: 'Art.Navigator.Academy',
        logo: artNavigatorLogo,
        description: 'Art.Navigator.Academy',
    },
    {
        id: 8,
        name: 'ТОВ “Карпатська енергія”',
        logo: carpathianEnergyLogo,
        description: 'ТОВ “Карпатська енергія”',
    },
    {
        id: 9,
        name: 'Факультет Психології КНУ ім. Т. Шевченка',
        logo: psychologyFacultyLogo,
        description: 'Факультет Психології КНУ ім. Т. Шевченка',
    },
];
